"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLotterySettlementUpdateInputSchema = exports.APosLotterySettlementCreateInputSchema = exports.APosLotterySettlementSchema = exports.APosLotterySettlementStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosLotterySettlementStatusSchema = zod_1.z.enum([
    'draft',
    'submitted',
    'confirmed',
    'paid',
]);
exports.APosLotterySettlementSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    settlementId: id_schema_1.EntityIdSchema,
    periodStart: zod_1.z.string().describe('ISO date string'),
    periodEnd: zod_1.z.string().describe('ISO date string'),
    status: exports.APosLotterySettlementStatusSchema,
    // Scratch-off totals
    scratchOffGrossSales: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    scratchOffPrizesPaid: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    scratchOffReturns: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    scratchOffBooksIncluded: zod_1.z.array(zod_1.z.string()).default([]),
    // Draw game totals
    drawGameGrossSales: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    drawGamePrizesPaid: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    // Summary totals
    totalGrossSales: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    totalPrizesPaid: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    totalReturns: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    netOwedToCommission: zod_1.z.number().int().default(0).describe('In cents'),
    commissionEarned: zod_1.z.number().int().min(0).default(0).describe('In cents'),
    locationId: id_schema_1.EntityIdSchema,
    submittedAt: zod_1.z.string().optional().describe('ISO datetime string'),
    confirmedAt: zod_1.z.string().optional().describe('ISO datetime string'),
    notes: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLotterySettlementCreateInputSchema = zod_1.z.object({
    periodStart: zod_1.z.string(),
    periodEnd: zod_1.z.string(),
    status: exports.APosLotterySettlementStatusSchema,
    locationId: id_schema_1.EntityIdSchema,
    scratchOffGrossSales: zod_1.z.number().int().min(0).optional(),
    scratchOffPrizesPaid: zod_1.z.number().int().min(0).optional(),
    scratchOffReturns: zod_1.z.number().int().min(0).optional(),
    scratchOffBooksIncluded: zod_1.z.array(zod_1.z.string()).optional(),
    drawGameGrossSales: zod_1.z.number().int().min(0).optional(),
    drawGamePrizesPaid: zod_1.z.number().int().min(0).optional(),
    totalGrossSales: zod_1.z.number().int().min(0).optional(),
    totalPrizesPaid: zod_1.z.number().int().min(0).optional(),
    totalReturns: zod_1.z.number().int().min(0).optional(),
    netOwedToCommission: zod_1.z.number().int().optional(),
    commissionEarned: zod_1.z.number().int().min(0).optional(),
    submittedAt: zod_1.z.string().optional(),
    confirmedAt: zod_1.z.string().optional(),
    notes: zod_1.z.string().optional(),
});
exports.APosLotterySettlementUpdateInputSchema = exports.APosLotterySettlementCreateInputSchema.partial();
//# sourceMappingURL=lottery-settlement.schema.js.map